import { render, staticRenderFns } from "./Keywords.vue?vue&type=template&id=c548545e&scoped=true&"
import script from "./Keywords.vue?vue&type=script&lang=ts&"
export * from "./Keywords.vue?vue&type=script&lang=ts&"
import style0 from "./Keywords.vue?vue&type=style&index=0&id=c548545e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c548545e",
  null
  
)

export default component.exports